import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { AccountCompanyService } from '../services/account-company.service';
import { CurrentCompanyService } from '../services/current-company.service';

/**
 * Used on the login route: if the user is already logged in, redirect to company
 * selection or the application when a company is already active.
 */
export const guestGuard: CanActivateFn = () => {
  const platformId = inject(PLATFORM_ID);
  const auth = inject(AuthService);
  const companyService = inject(AccountCompanyService);
  const currentCompanyService = inject(CurrentCompanyService);
  const router = inject(Router);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  if (!auth.isLoggedIn()) {
    return true;
  }

  if (companyService.isCompanyOpen()) {
    return router.createUrlTree(['/accounting']);
  }

  return currentCompanyService.resolveLoginCompanySelection().pipe(
    map(() => router.createUrlTree(['/accounting'])),
  );
};
